module.exports = __webpack_public_path__ + "img/Sabiat2.2322d5ee.jpg";